<template>
    <div id="keyBenefits" class="contentWrap">
        <div class="contentText">
            <div class="heading">Key benefits</div>
            <div class="bodyText">
                <p>DCIS is not a complete C2 turnkey solution in its own right. It enables you to efficiently integrate and use your existing communication systems.</p>
                <p>DCIS is a modular and scalable solution built on commercial off-the-shelf (COTS) software and government off-the-shelf software (GOTS), which can be deployed very quickly and be up and running in a few hours.</p>
                <p>Over time it can be expanded as requirements increase or change. DCIS is mission proven, secure and very robust. It will stay operational in all types of climates, environments and terrains from subarctic to desert.</p>
            </div>
        </div>
        <BenefitsPanel class="benefitsPanel">
            <div class="panelContent">
                <div class="column">
                    <IconListItem
                        itemContent="Tactical edge by rapid deployment in all types of climates and terrains"
                        iconName="svg_icons/desert.svg"
                    />
                    <IconListItem
                        itemContent="Integration of C2 system (legacy or new)"
                        iconName="svg_icons/laptop.svg"
                    />
                    <IconListItem
                        itemContent="<ul>
                            <li>Mission-proven in all climates</li>
                            <li>Supports international and national missions</li>
                            <li>Transparent command structure during all types of missions</li>
                        </ul>"
                        iconName="svg_icons/construction-site.svg"
                    />
                </div>
                <div class="column">
                    <IconListItem
                        itemContent="Easy maintainability in operation"
                        iconName="svg_icons/spanner.svg"
                    />
                    <IconListItem
                        itemContent="Modular and scalable – easy to upgrade"
                        iconName="svg_icons/outward-arrows.svg"
                    />
                    <IconListItem
                        itemContent="Can rapidly adapt for new or changing tasks/operations"
                        iconName="svg_icons/rotating-arrows.svg"
                    />
                    <IconListItem
                        itemContent="Low logistical footprint – adapted to deployed operations"
                        iconName="svg_icons/graph.svg"
                    />
                    <IconListItem
                        itemContent="Robust and secure communication"
                        iconName="svg_icons/signal-house-car.svg"
                    />
                </div>
            </div>
        </BenefitsPanel>
    </div>
</template>

<script>
import BenefitsPanel from '@/components/BenefitsPanel'
import IconListItem from '@/components/IconListItem'

export default {
    name: 'KeyBenefits',
    components: {
        BenefitsPanel,
        IconListItem,
    }
}
</script>

<style lang="scss" scoped>

#keyBenefits {
    padding: $menuHeight;
    background-image: url('../assets/images/top_level_backgrounds/key_benefits-background.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.contentWrap {
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

.contentText {
    flex: 0 1 40%;
    max-width: 65rem;
    text-align: left;
    margin-right: 5rem;
    p {
        font-size: 1.6rem;
        margin-bottom: 1.6rem;
        // line-height: 1.2;
    }
}

.heading {
    margin-bottom: 2rem;
    font-size: 4.8rem;
    line-height: 1;
}

.benefitsPanel {
    flex: 0 1 60%;
    max-width: 65rem;
    position: relative;
}


.panelContent {
    display: flex;
    .column {
        flex: 1 1 50%;
        &:nth-child(n+2) {
            margin-left: 2.5rem;
        }
    }
}
</style>

